import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";
import { getAuthUser } from "../libs/services/auth.service";

export const useUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userSession = await getAuthUser();
        setUser((_) => userSession);
      } catch (error: any) {
        setUser((_) => null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { user, loading };
};
